export const employees = {
  title_prefix: "Employees for ",
  health_title_prefix: "Personal for ",
  subtitle:
    "Manage employee IDs assigned to this organisation. You can create, edit, or remove employee information as needed.",
  health_subtitle:
    "Manage employee IDs assigned to this accommodation. You can create, edit, or remove employee information as needed.",
  empty_state_message:
    "Add employee IDs to start managing individuals within this organisation.",
  health_empty_state_message:
    "Add employee IDs to start managing individuals within this accommodation.",
  add_title_prefix: "Add Employee for ",
  health_add_title_prefix: "Add Personal for ",
  id_label: "ID",
  placeholder_id: "Enter ID here...",

  // Edit Employee Screen
  edit_title_prefix: "Edit Personal informations for ",
  edit_subtitle:
    "Update the personal ID information or remove it if it is no longer needed.",
  create_title_prefix: "Create Employee for ",
  create_subtitle: "Add a new employee to this organisation.",
  basic_information: "Basic information",

  // Form labels
  email_label: "Email",
  first_name_label: "First name",
  last_name_label: "Last name",
  nickname_label: "Nickname",
  date_of_birth_label: "Date of Birth",
  gender_label: "Gender",
  phone_number_label: "Phone number",
  location_label: "Location",
  settings_locked_label: "Settings Locked",

  // Placeholders
  placeholder_email: "Enter email here...",
  placeholder_first_name: "Enter first name here...",
  placeholder_last_name: "Enter last name here...",
  placeholder_nickname: "Enter nickname here...",
  placeholder_date_of_birth: "YYYY-MM-DD",
  placeholder_gender: "Enter gender here...",
  placeholder_phone_number: "Enter phone number here...",
  placeholder_location: "Enter location here...",

  // Gender options
  gender_male: "Male",
  gender_female: "Female",
  gender_prefer_not_to_say: "Prefer not to say",
};
